import { render, staticRenderFns } from "./nfcManually.vue?vue&type=template&id=00f40f6c&scoped=true&"
import script from "./nfcManually.vue?vue&type=script&lang=js&"
export * from "./nfcManually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f40f6c",
  null
  
)

export default component.exports